import { third, list } from 'components/CameraModelSelector/style'
import { COLORS } from 'helpers/globals'

export default {
  CameraDetailsContainer: {
    ...third,
    width: ({ lensSelector }) => lensSelector ? '50%' : '33%'
  },
  ModelCountDisplay: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'black',
    height: '100%',
    paddingTop: '22.5%',
    textAlign: 'center',
    lineHeight: '3rem',
    fontSize: '2.4rem'
  },
  filterSummary: {
    fontSize: '1.4rem',
    lineHeight: '2.2rem',
    marginTop: '1rem',
    marginBottom: '2rem'
  },
  missingCameraLink: {
    fontSize: '1.8rem',
    fontWeight: 400,
    color: 'white',
    background: COLORS.primary,
    padding: '.4rem .8rem',
    borderRadius: '.5rem',
    '&:hover': {
      color: 'white',
      background: COLORS.primaryHover
    }
  },
  break: {
    margin: '3rem 5% !important',
    width: '90%'
  },
  list
}



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/CameraDetailsContainer/style.js